import React from "react";
import { Link } from "react-router-dom";
import "../../App.css";

function Footer(props) {
  const [isShown, setIsShown] = React.useState(false);

  console.log(props, "footer props");
  return (
    <footer className="responsive-xs">
      {/* Footer Inner */}
      <section className="footerInner">
        <div className="container">
          <div className="row">
            <div className="foot-side">
              <div className="foot-nav-head">ABOUT</div>
              <a href="/additional/contactUs" className="foot-nav-list">
                Contact Us
              </a>
              <a href="/additional/aboutUs" className="foot-nav-list">
                About Us
              </a>
              <Link
                style={{
                  color: "white",
                  textDecoration: 0,
                  fontSize: 13,
                  fontWeight: 500,
                }}
                to="/franchise"
              >
                Franchise
              </Link>
              <a href="#" className="foot-nav-list">
                Corporate Information
              </a>
            </div>
            <div className="foot-side">
              <div className="foot-nav-head">HELP</div>
              <a href="#" className="foot-nav-list">
                Payments
              </a>
              <a href="#" className="foot-nav-list">
                Shipping
              </a>
              <a href="#" className="foot-nav-list">
                Cancellation &amp; Returns
              </a>
              <a href="#" className="foot-nav-list">
                FAQ
              </a>
              <a href="#" className="foot-nav-list">
                Report Infringement
              </a>
            </div>
            <div className="foot-side">
              <div className="foot-nav-head">POLICY</div>
              <a href="/additional/termsCondition" className="foot-nav-list">
                Terms & Condition
              </a>
              <a href="/additional/privacyPolicy" className="foot-nav-list">
                Privacy Policy
              </a>
              <a href="/additional/disclaimer" className="foot-nav-list">
                Disclamer
              </a>
              <a
                href="/additional/cancellationPolicy"
                className="foot-nav-list"
              >
                Cancellation policy
              </a>
            </div>
            <div className="foot-side">
              <div className="foot-nav-head">SOCIAL</div>
              <a href="https://www.facebook.com/" className="foot-nav-social">
                Facebook
              </a>
              <a href="https://www.twitter.com/" className="foot-nav-social">
                Twitter
              </a>
              <a href="https://www.youtube.com/" className="foot-nav-social">
                YouTube
              </a>
            </div>
            <div className="foot-side">
              <div className="foot-nav-head">
                <span>Mail Us :</span>
              </div>
              <div className="address-area">
                {/* <p>Jivimart Private Limited, </p> */}
                <p>
                  <a
                    className="text-white text-decoration-none"
                    href="mailto:hillmartventurespvtltd@gmail.com"
                  >
                    hillmartventurespvtltd@gmail.com{" "}
                  </a>
                </p>
                <p>
                  {" "}
                  <a
                    className="text-white text-decoration-none"
                    href="mailto:Aivimart8@gmail.com"
                  >
                    Aivimart8@gmail.com
                  </a>{" "}
                </p>
              </div>
            </div>
            <div className="foot-side">
              <div className="foot-nav-head">
                <span>Register Offices :</span>
              </div>
              <div className="address-area">
                <p>Hillmart Ventures Pvt ltd </p>
                <p> Khanapara, Guwahati, 781022 </p>
                <p> Assam, India</p>
                <p>
                  Call us at{" "}
                  <a
                    className="text-white text-decoration-none"
                    href="tel:+919181341366"
                  >
                    +91 9181341366
                  </a>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright d-flex align-items-center">
            <div className="col-md-2"></div>
            <div className="col-md-6">
              <p>
                Copyright Aivimart 2025 | Develop and Designed by{" "}
                <a
                  className="text-white text-decoration-none"
                  href="https://www.webinfotech.net.in/"
                >
                  Webinfotech
                </a>
              </p>
            </div>
            <div className="col-md-4">
              <img
                className="img-fluid"
                src={require("../../assets/payments.webp")}
              />
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
}

export default Footer;
